export default {
      count: 0,
      list: [],
      match: {},
      modified: false,
      selected: {_supplier:{contacts:[]},questions: [],answers: []},
      suppliers: [],
      question: {},
      templates: [],
      taglist:[],
      search: ""
    }
